import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { first, map, shareReplay } from "rxjs/operators";

import { DffContentRow, DffGroupedContent, formatDate, formatNumber } from "@dffedb/util";

import { MaalerTypeRepository } from "../maaler-type/maaler-type.repository";
import { MaalerAflaesning } from "../model/maaler-aflaesning.model";
import { TaellevaerkAflaesning } from "../model/taellevaerk-aflaesning.model";
import { TaellevaerkType } from "../model/taellevaerk-type.model";

@Injectable({ providedIn: "root" })
export class MaalerAflaesningKvitteringService {
    constructor(private readonly maalerTypeRepository: MaalerTypeRepository) {}

    public genererKvittering(model: MaalerAflaesning, datoForAflaesning?: Date): Observable<DffGroupedContent> {
        const maalerNr = { key: "Målernummer", value: model.maalerNr.aktuel };
        const dato = datoForAflaesning ? { key: "Dato for aflæsning", value: formatDate(new Date(datoForAflaesning), "DD-MM-YYYY") } : null;
        return this.mapAflaesninger(model).pipe(
            map((aflaesninger) => ({
                groups: [
                    {
                        title: "Aflæsning",
                        rows: [dato, maalerNr, ...aflaesninger].filter((r) => !!r)
                    }
                ]
            }))
        );
    }

    private mapAflaesninger(aflaesning: MaalerAflaesning): Observable<DffContentRow[]> {
        return this.maalerTypeRepository.hentMaalerTyper().pipe(
            first(),
            map((maalerTyper) => {
                const maalerType = maalerTyper.find((mt) => mt.id === aflaesning.maalerTypeId.aktuel);
                return aflaesning.taellevaerker.map((taellevaerkAflaesning) => {
                    const taellevaerkType = maalerType.taellevaerker.find((tv) => tv.enhedType === taellevaerkAflaesning.enhedType);
                    return this.toRow({ ...taellevaerkAflaesning, ...taellevaerkType });
                });
            }),
            shareReplay(1)
        );
    }

    private toRow(value: TaellevaerkType & TaellevaerkAflaesning): DffContentRow {
        return { key: value.beskrivelse, value: this.formatNumber(value.aflaesning.aktuel, value.enhed) };
    }

    private formatNumber(value: number, suffix: string): string {
        const formattedValue = formatNumber(value, `1.0-9`);
        return `${formattedValue} ${suffix}`;
    }
}
